export function getBlockedAttendanceKey(item = {}) {
  if (item.pacient_id != null) return `patient:${item.pacient_id}`
  if (item.atendimento_id != null) return `attendance:${item.atendimento_id}`
  if (item.attendance_id != null) return `attendance:${item.attendance_id}`
  if (item.id != null) return `attendance:${item.id}`
  if (item.replacement_request_id != null) return `replacement:${item.replacement_request_id}`

  return [
    item.agenda_id,
    item.start,
    item.start_time,
    item.end_time,
    item.professional_id,
    item.specialty_id
  ].map((value) => String(value ?? '')).join(':')
}
